import { AppSeason } from 'common/types/theme';
import getBaseTheme from './baseTheme';
import { pSBC } from './color-converter';
import { Theme } from './types';

const primaryColor = '#A59C97';
const getTheme = ({
  condensedMode,
  responsive,
  windowHeight,
  windowWidth,
}: {
  condensedMode: boolean;
  responsive: boolean;
  windowWidth: number;
  windowHeight: number;
}): Theme => {
  const baseTheme = getBaseTheme({ primaryColor, responsive, condensedMode, windowWidth, windowHeight });

  return {
    ...baseTheme,
    name: AppSeason.Winter,
    colors: {
      ...baseTheme.colors,
      primary: primaryColor,
      sideNavigation: '#C5C5C5',
      sideNavigationTop: '#8B847C',
      sideNavigationHover: '#B4B0B0',
      coloredText: '#545454',
      cardBackground: pSBC(0.92, primaryColor),
      primaryTransparent: (transparency) => `rgba(165, 156, 151, ${transparency})`,
      primaryDarker: (darkness) => pSBC(-1 * darkness, primaryColor),
      primaryLighter: (lightness) => pSBC(lightness, primaryColor),
    },
  };
};

export default getTheme;
